const MobileNav = () => {
  const hamburger = document.querySelector(".mobile-nav-button");
  const bodyClass = document.querySelector("body");
  let expanded = hamburger.getAttribute("aria-expanded");

  const closeNav = () => {
    hamburger.classList.remove("nav-open");
    hamburger.classList.add("nav-closed");
    document.body.classList.remove("show-mobile-nav");
    document.body.classList.add("hide-mobile-nav");
    if (expanded === "true") {
      expanded = "false";
      hamburger.setAttribute("aria-expanded", expanded);
    }
  };

  const openNav = () => {
    hamburger.classList.remove("nav-closed");
    hamburger.classList.add("nav-open");
    document.body.classList.add("show-mobile-nav");
    document.body.classList.remove("hide-mobile-nav");
    if (expanded === "false") {
      expanded = "true";
      hamburger.setAttribute("aria-expanded", expanded);
    }
  };

  const showNav = () => {
    hamburger.onclick = () => {
      if (hamburger.classList.contains("nav-closed")) {
        openNav();
      } else {
        closeNav();
      }
    };
  };

  const nav = () => {
    const windowWidth =
      window.innerWidth ||
      document.documentElement.clientWidth ||
      document.body.clientWidth;

    if (windowWidth < 767 && !bodyClass.classList.contains("show-mobile-nav")) {
      bodyClass.classList.add("hide-mobile-nav");
      showNav();
    }

    if (windowWidth > 767 && bodyClass.classList.contains("show-mobile-nav")) {
      bodyClass.classList.remove("hide-mobile-nav");
      closeNav();
    }
  };

  window.addEventListener("resize", nav);
  nav();
};

export default MobileNav;
